var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 2.95312V11.2865C18.3307 11.839 18.1112 12.3689 17.7205 12.7596C17.3298 13.1503 16.7999 13.3698 16.2474 13.3698H3.7474C3.19486 13.3698 2.66496 13.1503 2.27426 12.7596C1.88356 12.3689 1.66406 11.839 1.66406 11.2865V2.95312",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 2.95052C18.3307 2.39799 18.1112 1.86808 17.7205 1.47738C17.3298 1.08668 16.7999 0.867188 16.2474 0.867188H3.7474C3.19486 0.867188 2.66496 1.08668 2.27426 1.47738C1.88356 1.86808 1.66406 2.39799 1.66406 2.95052L8.89323 7.46441C9.22434 7.67135 9.60694 7.78108 9.9974 7.78108C10.3879 7.78108 10.7705 7.67135 11.1016 7.46441L18.3307 2.95052Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ea639fc45ef48046dd727f50c63c98d8.svg";
export { ForwardRef as ReactComponent };